import React, { useState, useEffect } from 'react';
import apiUrl from '../../Apiurl';
import BrandVoceCliccabile from '../BrandVoceCliccabile';

function ColonnaBrand(props) {

    const brandSelezionato = props.brandSelezionato;
    const setBrandFunction = props.setBrandFunction;
    const setListaProdottiBrand = props.setListaProdottiBrand;

    const [listaBrand, setListaBrand] = useState([]);
    

    useEffect(() => {
        fetch(apiUrl + "/prodotti/get/brand")
          .then(resp => resp.json())
          .then(data => setListaBrand(data))
      }, []);

        

    return(        
            <div className='pl3 sezioneConScroll colonnaTuttaPagina'>
            {listaBrand.map((brand,i) => (
                <BrandVoceCliccabile
                    key={brand}
                    nomeBrand={brand}
                    brandSelezionato={brandSelezionato}
                    setBrandFunction={setBrandFunction}
                    setListaProdottiBrand={setListaProdottiBrand}
                    />
            ))}
            </div>
        )
}


export default ColonnaBrand;
